
import { defineComponent } from "vue";
import GameWrapper from "@/components/GameWrapper.vue";
import GameMatrix from "@/data/GameMatrix";
import GameMatrixDisplay from "@/components/GameMatrixDisplay.vue";
import TimerBox from "@/components/TimerBox.vue";
import Timer from "@/data/Timer";
import GameInfoPoint from "@/components/GameInfoPoint.vue";
import { ScoreElement } from "@/data/types";

type FalseCountInfo = { id: number; info: string; value: false };

export default defineComponent({
  name: "CountUp",

  components: {
    GameWrapper,
    GameMatrixDisplay,
    TimerBox,
    GameInfoPoint,
  },

  data() {
    return {
      isGameOver: true,
      restartCounter: 0,
      gameMatrix: new GameMatrix(),
      gameTimer: new Timer(),
      gameTimeThreshold: 50,
      falseCounts: [] as FalseCountInfo[],
      numbersConfirmed: 0,
    };
  },

  computed: {
    scoreElements(): ScoreElement[] {
      let timerValue = this.gameTimer.seconds;
      return [
        {
          id: 0,
          info: "Game clear",
          value: this.gameTimeThreshold,
        },
        {
          id: 1,
          info: "Time penalty",
          value: -(timerValue - this.gameTimeThreshold),
        },
        {
          id: 2,
          info: "False counts",
          value: -this.falseCounts.length,
        },
      ];
    },
    matrixDisplayWidth(): number {
      //TODO: change once different matrix sizes supported
      return 23;
    },
  },

  methods: {
    restart(): void {
      this.restartCounter += 1;
      this.isGameOver = false;
      this.gameTimer.reset();
      this.falseCounts = [];
      this.numbersConfirmed = 0;
    },
    endGame(): void {
      this.isGameOver = true;
      this.gameTimer.stop();
    },
    newRound() {
      this.gameMatrix.generateNumberMatrix(7, 7, true);
      this.gameMatrix.shuffle();
      this.gameTimer.start();
    },
    confirmNumber(id: number) {
      if (id === this.numbersConfirmed) {
        let item = this.gameMatrix.get(id);
        if (item) {
          item.isClickable = false;
        }
        this.numbersConfirmed += 1;
      } else {
        this.falseCounts.push({
          id: this.falseCounts.length,
          info: `Wrong: ${this.numbersConfirmed} -> ${id + 1}`,
          value: false,
        });
      }
      if (this.numbersConfirmed === this.gameMatrix.size) {
        this.endGame();
      }
    },
  },
});
